import React, {useState} from 'react';
import Button from "@material-ui/core/Button";
import "../../assets/css/order.css";
import {savePDF} from '@progress/kendo-react-pdf';
import {drawDOM, exportPDF} from '@progress/kendo-drawing';
import {saveAs} from '@progress/kendo-drawing/pdf';
import {Auth} from 'aws-amplify';
import {useHistory} from 'react-router-dom';
import Loading from '../../../src/views/components/Loading';
import {apiEndPoint} from '../../env'
import {CRITICAL_ACTION_TIMEOUT} from '../../constants/values';
import {isMobile} from 'react-device-detect';
import {AuthUtil} from "../../views/auth/AuthUtil";

export default (props) => {
  const [loaded, setLoaded] = useState(true);
  const bodyRef = React.createRef();
  const history = useHistory();
  const {details, duration, generated} = props;
  let result = null;
  const handlePDF = async () => {
    setLoaded(false);
    let filename = details.serial_number+'_'+details.client_name+'_'+duration.start+'_'+duration.end;
    result = await convertPDF(filename);
    // alert('result from convertPDF:' + result);
    try {
      const controller = new AbortController();
      let token = await AuthUtil.getAuthToken();
      const clientName = details.client?.client_name ?? details.client_name;
      const clientDisplay = details.client?.client_display ?? details.client_display ?? details.client_email;
      const clientPhone = details.client?.client_phone ?? details.client_phone;
      const requestOptions = {
        // crossDomain: true,
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Authorization': token},
        signal: controller.signal,
        credentials: 'include',
        body: JSON.stringify({
          device_name: details.device_name,
          email: details.email,
          serial_number: details.serial_number,
          filename: details.email+'_'+filename,
          // types: "hr_btn",
          client_name: clientName,
          client: {
            client_name: clientName,
            client_display: clientDisplay,
            client_phone: clientPhone,
          },
          generated_date: generated,
          measurement_start: duration.start,
          measurement_end: duration.end,
          filebody: result,
          radondata: details.radondata,
        }),
      };
      let requestUrl = apiEndPoint + '/report';
      const timeoutId = setTimeout(() => controller.abort(), CRITICAL_ACTION_TIMEOUT);
      let fetchRes = await fetch(requestUrl, requestOptions);
      let uploadResult = await fetchRes.json();

      if (uploadResult.resultcode >= 200 && uploadResult.resultcode < 300) {
        window.open(uploadResult.data.pdf_url);
        history.push('/reports/list');
      }
    } catch (e) {
      alert('failed upload the generated report, details: ' + e);
    }
    setLoaded(true);
  };

  const convertPDF = (filename) => {
    let pdfRootHtmlElement = document.getElementById('pdfRoot');
    let res =
      drawDOM(pdfRootHtmlElement, {
        scale: 0.7,
        paperSize: 'Letter',
        fileName: 'test.pdf',
        margin: 0
      }).then((group) => {
        return exportPDF(group);
      }).then((dataUri) => {
        let encoded = dataUri.split(";base64,")[1];
        return encoded;
      });

    savePDF(pdfRootHtmlElement, {
      scale: 0.7,
      paperSize: 'Letter',
      fileName: filename+'.PDF',
      margin: 0
    });

    return res;
  }

  return (
    <>
      {loaded ?
        (<section className="pdf-container">
          <section className="pdf-body" ref={bodyRef}>
            {props.children}
          </section>
          <section className="download-pdf">
            {
              !isMobile ? (
                <Button onClick={handlePDF} variant="contained" color="primary" mt={2}
                        classes={{root: 'button', label: 'button-label'}} style={{width: '130px'}}>
                  Save
                </Button>
              ) : (
                <></>
              )
            }
          </section>
        </section>) : <Loading></Loading>}
    </>
  )
}
